import { DATABASE_NAME } from '@env'
import { doc, collection, onSnapshot } from 'firebase/firestore'
import { db } from '../config'
import '../../global'
import { checkSnooze } from '../../helpers/checkSnooze'

// Format Modifier Lists
export function formatModifierLists(data: any) {
	return {
		id: data.id,
		max: data.max,
		min: data.min,
		name: data.name,
		restaurantId: data.restaurantId,
		selectionType: data.selectionType,
		variation: data.variation || false,
		modifierItems: [],
	}
}

// Format Modifier Items
export function formatModifierItems(modItem: any, restaurantId: string) {
	return {
		id: modItem.id,
		name: modItem.name,
		amount: modItem.priceMoney?.amount || 0,
		restaurantId: restaurantId,
		isSnoozed: modItem.isSnoozed,
		snoozeUntil: modItem.snoozeUntil,
		imageUrl: modItem.imageUrl,
		isRecommended: modItem.isRecommended,
		isDeleted: modItem.isDeleted,
		ordinal: modItem.ordinal || 9999,
		variation: modItem.variation || false,
	}
}

export const getModifierData = (restaurantId, snapshot) => {
	return new Promise((resolve, reject) => {
		const dataImport = {}

		snapshot.docChanges().forEach(change => {
			const data = change.doc.data()
			if (!data.isDeleted) {
				const modListReturn = formatModifierLists(data)

				if (data.modifierItems) {
					const modItems: any = Object.values(data.modifierItems)
					modListReturn.modifierItems = modItems.reduce((acc, modItem) => {
						if (!checkSnooze(modItem.isSnoozed, modItem.snoozeUntil) && !modItem.isDeleted) {
							const modItemReturn = formatModifierItems(modItem, restaurantId)
							const key = 'items_for_' + data.id
							const key2 = 'mod_item_' + modItem.id

							if (!dataImport[key]) {
								dataImport[key] = []
							}

							if (change.type === 'modified') {
								const index = dataImport[key].findIndex(i => i.id === modItem.id)
								if (index >= 0) {
									dataImport[key].splice(index, 1)
								}
							}

							dataImport[key].push(modItemReturn)
							dataImport[key2] = modItemReturn

							acc.push(modItemReturn)
						}
						return acc
					}, [])
				}
				if (modListReturn.modifierItems?.length > 0) {
					dataImport[data.id] = modListReturn
				}
			}
		})

		resolve(dataImport)
	})
}
